import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants.js";

const translation = {
  consentModal: {
    title: "Beekumsa Kukeewwan",
    description:
      "Marsariitii kana sirnaan akka hojjetu kukeewwan barbaachisoo ni fayyadama. Akkasumas kukeewwan hordoffii filannoo fayyadamuun, akkamitti marsariitii keenya waliin wal qunnamuu akka jirtu nu gargaara. Kukeewwan filannoo kunneen oggola kee qofaan ni dhaabbatu.",
    acceptAllBtn: "Hunduma fudhadhu",
    acceptNecessaryBtn: "Hunduma haqu",
    showPreferencesBtn: "Filannoo dhuunfaa to’achiisi",
  },
  preferencesModal: {
    title: "Filannoo Kukeewwan To’achuuf",
    acceptAllBtn: "Hunduma fudhadhu",
    acceptNecessaryBtn: "Hunduma haqu",
    savePreferencesBtn: "Filannoo ammaa fudhadhu",
    closeIconLabel: "Foddaa cufi",
    sections: [
      {
        title: "Fayyadama Kukeewwan",
        description:
          "Kukeewwan hojiiwwan barbaachisoo marsariitii kana deeggaruu fi muuxannoo qu’annaa fooyyessuuf itti fayyadama.",
      },
      {
        title: "Kukeewwan sirriitti barbaachisan",
        description:
          "Kukeewwan kunneen hojii sirrii marsariitii eeguuf murteessaadha, fakkeenyaaf mirkaneessa fayyadamaa.",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: {
            name: "Maqaa",
            domain: "Tajaajila",
            description: "Ibsa",
            expiration: "Yeroo Xumuraa",
          },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description:
                "Kukeen kun bu’uura hawaasa dijitaalaa fayyadama mirkaneessuuf taasifame.",
              expiration: "Turtii",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description:
                "Kukeen kun bu’uura hawaasa dijitaalaa fayyadama mirkaneessuuf taasifame",
              expiration: "Turtii",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "Kukeen kun nama fi robot gidduutti adda baasuun, marsariitii badiin tokkoffaan ittisuuf ni tajaajila. Odeeffannoo dhuunfaa hin funaanamu.",
              expiration: "Daqiiqaa 30",
            },
          ],
        },
      },
      {
        title: "Falannoo",
        description:
          "Kukeewwan falannoo odeeffannoo walitti qabuu fi tajaajilli tokko akkamitti fayyadamaa waliin akka wal qunnamu gahuuf ni gargaara. Odeeffannoon kunis qabiyyee fooyyessuu fi amaloota gaarii ijaaruu keessatti ni tajaajila.",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: {
            name: "Maqaa",
            domain: "Tajaajila",
            description: "Ibsa",
            expiration: "Yeroo Xumuraa",
          },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'Kukeen <a href="https://business.safety.google/adscookies/">Google Analytics</a> tiin uumame',
              expiration: "Guyyaa 12 booda ni dhuma",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'Kukeen <a href="https://business.safety.google/adscookies/">Google Analytics</a> tiin uumame',
              expiration: "Turtii",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel =
  "Kuusaa falannoo waliin walqabate, fakkeenyaaf turtii daawwannaa ni dandeessisa.";

export { translation, servicesLabel };
